<div class="modal-header border-0">
  <div class="position-relative text-center">
    <div *ngIf="!isSuccess && showBack"
         class="form-back-btn-chevron"
         (click)="onFormChange.emit()">
      <i class="icon-chevron-left"></i>
    </div>
    <span class="font-xl fw-bold uppercase"
          [translate]="'modal.contactUs.header'">Contact us</span>
  </div>
</div>
<div class="modal-body">
  <ui-message class="d-block mb-4"
              *ngIf="isSuccess"
              [type]="'success'">
    {{'modal.contactUs.sendMessageSuccess' | translate}}
  </ui-message>

  <form *ngIf="!isSuccess" [formGroup]="contactUsForm">
    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="font-xl fw-bold"
                 [translate]="'modal.contactUs.name'">Your name</label>
          <input class="form-control"
                 placeholder="{{'common.name' | translate}}..."
                 [maxlength]="'32'"
                 formControlName="userName">
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="font-xl fw-bold"
                 [translate]="'modal.contactUs.city'">Your city</label>
          <input class="form-control"
                 placeholder="{{'modal.contactUs.cityPlaceholder' | translate}}..."
                 [maxlength]="'64'"
                 formControlName="city">
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="form-group">
          <label class="font-xl fw-bold"
                 [translate]="'modal.contactUs.phone'">Your phone number</label>
          <input class="form-control"
                 placeholder="{{'modal.contactUs.phonePlaceholder' | translate}}..."
                 [inputMask]="'phone'"
                 [maxlength]="'32'"
                 formControlName="phone">
        </div>
      </div>

      <div class="col-sm-6">
        <div class="form-group">
          <label class="font-xl fw-bold"
                 [translate]="'modal.contactUs.email'">Your E-mail address</label>
          <input class="form-control"
                 placeholder="{{'common.email' | translate}}..."
                 [pattern]="EMAIL_PATTERN"
                 [maxlength]="'128'"
                 formControlName="email">
        </div>
      </div>
    </div>

    <div class="form-group">
      <label class="font-xl fw-bold"
             [translate]="'modal.contactUs.message'">Your massage</label>
      <textarea class="form-control" rows="4"
                placeholder="{{'modal.contactUs.messagePlaceholder' | translate}}..."
                [maxlength]="'512'"
                formControlName="message"></textarea>
    </div>

    <div class="text-end mt-2rem">
      <button class="btn btn-pink px-5"
              [disabled]="contactUsForm.invalid"
              (click)="send()"
              [translate]="'common.send'">
        Send
      </button>
    </div>

    <div class="text-center mt-4 mb-2rem font-xl">
      <div [innerHTML]="'modal.contactUs.callUs' | translate"></div>
      <div class="mt-2" [innerHTML]="'modal.contactUs.sendEmail' | translate"></div>
    </div>
  </form>
</div>
